export const formatCurrency = (amount: number, currency = 'UZS', isMinorUnits = true) => {
    const normalizedAmount = isMinorUnits ? amount / 100 : amount;

    return new Intl.NumberFormat('uz-UZ', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
    }).format(normalizedAmount);
};

export const formatDateTime = (value?: string | null) => {
    if (!value) {
        return '—';
    }

    const normalized = value.replace(' ', 'T');
    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat('uz-UZ', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};

export const formatSubscriptionType = (value: string) => {
    const map: Record<string, string> = {
        monthly: "oylik",
        yearly: "yillik",
        weekly: "haftalik",
        daily: "kunlik",
    };

    return map[value] || value;
};

export const formatTariffDuration = (subscriptionType: string, periodCount?: number, periodSeconds?: number) => {
    const count = periodCount && periodCount > 0 ? periodCount : 1;

    if (subscriptionType === 'monthly') {
        return `${count} oy`;
    }

    if (subscriptionType === 'yearly') {
        return `${count} yil`;
    }

    if (subscriptionType === 'weekly') {
        return `${count} hafta`;
    }

    if (subscriptionType === 'daily') {
        return `${count} kun`;
    }

    if (periodSeconds) {
        const days = Math.max(1, Math.round(periodSeconds / 86400));
        return `${days} kun`;
    }

    return `${count} ${formatSubscriptionType(subscriptionType)}`;
};

export const maskCardPan = (pan: string) => {
    if (!pan) {
        return '—';
    }

    return pan.length > 4 ? `**** **** **** ${pan.slice(-4)}` : pan;
};
